module.exports = __webpack_public_path__ + "static/img/sec2-cont-main@t.45d6071.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/sec2-cont-main@t.jpg
// module id = 8QlR
// module chunks = 0